import '../../App.scss'
import React, { Component } from 'react'
import Artifact from './Artifact';
import Glyph from './Glyph';
import Seo from '../seo/Seo';
import HeroMystery from './HeroMystery';

export default class GlyphsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            searchBox: '',
            previous: '',
            data: {
                nextPageToken: undefined,
                items: [{
                    content: '',
                    title: 'loading...',
                    blog:
                    {
                        id: 'loading'
                    }
                }
                ]
            }
        };
    }
    async componentDidMount() {
        await fetch('https://www.googleapis.com/blogger/v3/blogs/3917238484875234696/posts?key=AIzaSyDncvsDJ8auOX6KnFm3Vl9qHDdgbkB6oRQ')
            .then(response => response.json())
            .then(data => this.setState({ data: data, nextPage: data.nextPageToken}))
        await this.checkData();
       
    }
    checkData = async() => {
        if(this.state.nextPage === undefined){
            console.log('no more pages')
        }
        let i;
        for (i = 1; i < 10; i++){
            console.log('hit ' + i)
            console.log('token is ' + this.state.nextPage)
            if(this.state.nextPage !== undefined){
              await  fetch(`https://www.googleapis.com/blogger/v3/blogs/3917238484875234696/posts?key=AIzaSyDncvsDJ8auOX6KnFm3Vl9qHDdgbkB6oRQ&pageToken=${this.state.nextPage}`)
                .then(response => response.json())
                .then(data => this.joinArr(data.items, data.nextPageToken))      
            } else{
                return
            }
            }
    }
    joinArr = (toJoin, nextP, results) => {
        let joined = this.state.data.items.concat(toJoin)
        this.setState({data:{items: joined}})
        let totalFound = this.state.data.items.length
        results ? this.setState({totalResults: totalFound}) : console.log('Not a Search')
        console.log(joined)
        if(nextP === undefined){
            this.setState({nextPage: undefined, nextPageSearch: undefined})
            return
        }
        else{
            this.setState({nextPage: nextP})
        }
    }
   dynamicSort=(property)=> {
        var sortOrder = 1;
        if(property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a,b) {
            /* next line works with strings and numbers, 
             * and you may want to customize it to your needs
             */
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        }
    }
    search = async () => {
        let phrase = this.state.searchBox
        this.setState({
           search: phrase,
        })
        // if (!this.state.search.replace(/\s/g, '').length) {
        //     alert('you cannot search for nothing')
        //     return
        //   }
        // let search = this.state.search.replace(/\s/g, '+')
        // let saveSearch = this.state.search
       
        // await fetch(`https://www.googleapis.com/blogger/v3/blogs/3917238484875234696/posts/search?q=${search}&key=AIzaSyDncvsDJ8auOX6KnFm3Vl9qHDdgbkB6oRQ`)
        //     .then(response => response.json())
        //     .then(results => {
        //         results.items ? this.setState({ data: results, totalResults: results.items.length, previous: saveSearch, nextPageSearch: results.nextPageToken}) : alert('Sorry we were unable to find any results that matched.')
        //     })
        // await this.checkSearchData()
    }
    // checkSearchData = async() => {
    //     if(this.state.nextPageSearch === undefined){
    //         console.log('no more pages')
    //         return
    //     }
    //     let i;
    //     for (i = 1; i < 10; i++){
    //         if(this.state.nextPageSearch !== undefined){
    //             console.log(`https://www.googleapis.com/blogger/v3/blogs/3917238484875234696/posts/?key=AIzaSyDncvsDJ8auOX6KnFm3Vl9qHDdgbkB6oRQ&q=${this.state.previous}&pageToken=${this.state.nextPageSearch}`)
    //           await  fetch(`https://www.googleapis.com/blogger/v3/blogs/3917238484875234696/posts/?pageToken=${this.state.nextPageSearch}&key=AIzaSyDncvsDJ8auOX6KnFm3Vl9qHDdgbkB6oRQ?q=${this.state.previous}`)
    //             .then(response => response.json())
    //             .then(data => this.joinArr(data.items, data.nextPageToken, true))      
    //         } else{
    //             return
    //         }
    //         }
    // }   
    render() {
        const Input = () => {
            const handleKeyDown = (event) => {
              if (event.key === 'Enter') {
                this.search()
              }
            }
          
            return <input onChange={e => this.setState({ searchBox: e.target.value })} type="text" onKeyDown={handleKeyDown} />
          }
        return (
            <div>
                  <Seo 
                title="Mystery Glyphs"
                image="https://1.bp.blogspot.com/-pBlgX3Qxfxc/YCxWzX2JuiI/AAAAAAAAnAw/1AxVaA_0dqUWsqry5XJoFX5v2nIsZ5kDgCLcBGAsYHQ/s1920/Mystery%2BGlyphs%2BCover.jpg"
                description="Across the Western United States a Mystery is Unfolding"

                />
                <div className="TopBar">
                    <div className="TopDivider">
                        <h1>Mystery Glyph Sites Confirmed by AHRF </h1>
                        <div className="SearchBar">
                            {Input()}
                            <div onClick={()=>this.search()}className="Register">Search</div>
                            <div className="AboutTop">
                                <p>We have documented over 30+ Mystery Gylph locations. If you are aware of these sites, please respect them and keep their location quiet to help preserve them and prevent vandalism.</p>
                            </div>
                                <p>Each card below identifies a particular Mysyery Glyph Panel by the state it is found in, and an assigned number. If there is more than one panel at a site, an additional number is given.</p>
                        </div>
                            {/* <p>{this.state.totalResults ? this.state.totalResults + ' result(s) found for ' + "'" + this.state.previous + "'" : ''}</p> */}
                    </div>
                </div>
                <div className="MuseumList">

                    {this.state.data.items.sort(this.dynamicSort("title")).filter((element, index) =>{
            return element.title.toLowerCase().includes(this.state.search.toLowerCase())
        }).map((info, index) => (
                        <Glyph
                            info={info} />
                    ))}

                </div>
            </div>
        );
    }
}
